import { Metamodel } from 'app/model/base/model';
import { Activity } from './activity';
import { AzureStorageLinkedService } from 'app/model/linkedservice/azure-storage.linkedservice';
import { ModelConstants } from 'shell-models-lib';


@Metamodel.model({
    name: ModelConstants.scriptFlowActivity
})
export abstract class ScriptFlowActivity extends Activity {
    @Metamodel.attribute({
        display: __IS_FABRIC_DPE__ ? stringResources.ModelName_ScriptConnection : stringResources.ModelName_ScriptLinkedservice,
        constraint: {
            required: true
        },
        reference: true,
        type: AzureStorageLinkedService.MODEL
    })
    public scriptLinkedService?: AzureStorageLinkedService;

    public abstract getFullScriptPath(): string;
}
